<template>
  <div :class="{ 'artist-venue-card-big' : size === 'big' }"
       class="artist-venue-card">
    <div class="image-link">
      <b-img-lazy :src="element.thumbnails ? element.thumbnails.s_cd : require(`@/assets//images/placeholder-${type}.svg`)"
                  :alt="element.name | removeQuotes"
                  :class="`${type}`"
                  fluid
                  @error.native="$event.target.src = require(`@/assets//images/placeholder-${type}.svg`)" />
    </div>
    <div class="info-card">
      <span class="artist-venue-name">
        <fit-text target-line-count="2"
                  min="0.75">{{ element.name | truncate(35) }}</fit-text>
        <p v-if="element.events_count"
           class="artist-venue-events">{{ element.events_count }} {{ $t('artistVenueCard.conciertos') }} </p>
      </span>
      <follow-button :element-id="element.id"
                     :user="element.user"
                     :type="type"
                     class="small-follow-button" />
    </div>
  </div>
</template>

<script>
import FollowButton from '@/components/follow-button/FollowButton.vue'
import FitText from '@/components/externals/fit-text/FitText.vue'

export default {
  components: {
    FitText,
    FollowButton
  },
  props: {
    element: {
      type: Object,
      default: () => {}
    },
    type: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'small'
    }
  }
}
</script>

<style lang="scss">
@import './artist-venue-card.sass'
</style>
